import React from "react";

/**
 * Token-styled toggle switch. Replaces `Form.Check type="switch"`, which
 * renders as a bare checkbox in this app because Bootstrap's switch CSS is
 * shadowed by global page styles.
 */
const Toggle: React.FC<{
  checked: boolean;
  onChange: () => void;
  disabled?: boolean;
  "aria-label"?: string;
}> = ({ checked, onChange, disabled, ...rest }) => (
  <label className="tcs-toggle">
    <input
      type="checkbox"
      checked={checked}
      disabled={disabled}
      onChange={onChange}
      aria-label={rest["aria-label"]}
    />
    <span className="tcs-toggle-track" />
  </label>
);

export default Toggle;
